/**
 * Frontend delta helper for live block-exit capture. Diffs a single form block
 * (attribute) against its last-saved baseline and emits one UPDATE per changed
 * field. Matched by stable id; mirrors the backend `IDocChange` shape.
 */

const stable = (v) => JSON.stringify(v ?? null);
const isChanged = (a, b) => stable(a) !== stable(b);

export const computeAttributeDelta = (oldAttr, newAttr, sectionId, label) => {
    const changes = [];
    if (!oldAttr || !newAttr) return changes;
    const target = { entity: 'ATTRIBUTE', sectionId, attributeId: newAttr.id, label };
    const keys = new Set([...Object.keys(oldAttr), ...Object.keys(newAttr)]);
    for (const field of keys) {
        if (field === 'id') continue;
        if (isChanged(oldAttr[field], newAttr[field])) {
            changes.push({ changeType: 'UPDATE', target: { ...target, field }, before: oldAttr[field], after: newAttr[field] });
        }
    }
    return changes;
};
